import { BynameSeeds } from "./BynameSeeds"
import { NamePlateSeeds } from "./NamePlateSeeds"

export class TempProfile {
    constructor(userdata, profile) {
        if (window.structuredClone) {
            this.profile = structuredClone(profile)
            this.userdata = structuredClone(userdata)
        } else {
            this.profile = JSON.parse(JSON.stringify(profile))
            this.userdata = JSON.parse(JSON.stringify(userdata))
        }
        this.nameplaterng = new NamePlateSeeds(this.profile, this.userdata)
        this.bynamerng = new BynameSeeds(this.profile, this.userdata)
    }

    set_profile(e) {
        this.profile = e
    }

    update_userdata() {
        this.nameplaterng.update_seed(this.userdata)
        this.bynamerng.update_seed(this.userdata)
        return this.userdata
    }
}
